import { useAccountTypeBrowse } from "@features/tickets/shared/hooks/useAccountTypeBrowse";
import { CASH_BOX_ACCOUNT_TYPE } from "./cashBoxes.constants";

export function useCashBoxesBrowse() {
  return useAccountTypeBrowse({
    accountType: CASH_BOX_ACCOUNT_TYPE,
  });
}
